import logo from '../AZWG_Emblem_Transparent.png';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import { useEffect, useState } from 'react';
import { Button, Dropdown, Spinner } from 'react-bootstrap';
import { fetchCurrentUser, logout, getLoginUrl } from '../api/api';
import ProfileModal from './ProfileModal';

const HornNavbar = () => {
    const [user, setUser] = useState(null);
    const [showProfile, setShowProfile] = useState(false);
    const [isLoadingUser, setIsLoadingUser] = useState(false); // new state

    useEffect(() => {
      const fetchUser = async () => {
        setIsLoadingUser(true); // start loading
        try {
          const data = await fetchCurrentUser();
          setUser(data);
        } catch (err) {
          setUser(null);
        } finally {
          setIsLoadingUser(false); // stop loading
        }
      };
      fetchUser();
    }, []);

    const handleLogout = async () => {
      try {
        await logout();
      } catch (e) {
        // ignore
      }
      setUser(null);
      // optional: reload to refresh any protected data
      window.location.reload();
    };

    return (
   <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/">
            <img
              alt=""
              src={logo}
              width="30"
              height="30"
              className="d-inline-block align-top"
            />{' '}
            Airman's Attic
          </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="inventory">Inventory</Nav.Link>
            {/* <Nav.Link href="locations">Locations</Nav.Link> */}
            <Nav.Link href="items">Items</Nav.Link>
            {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
          </Nav>

          {/* Right side: login / user */}
          <Nav className="ms-auto" style={{ alignItems: 'center' }}>
            {user ? (
              <Dropdown align="end">
                <Dropdown.Toggle variant="outline-secondary" id="user-dropdown" size="sm" style={{ borderRadius: 6 }}>
                  {user.user_name || user.email || 'User'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setShowProfile(true)}>
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button
                variant="primary"
                size="sm"
                onClick={() => { window.location.href = getLoginUrl(); }}
                style={{ borderRadius: 6, marginLeft: 8 }}
                disabled={isLoadingUser} // disable while loading
              >
                {isLoadingUser ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: 6 }}
                    />
                    Loading...
                  </>
                ) : (
                  'Login'
                )}
              </Button>
            )}
          </Nav>

        </Navbar.Collapse>
      </Container>

     {/* Profile modal */}
     <ProfileModal
       show={showProfile}
       onHide={() => setShowProfile(false)}
       user={user || {}}
       onLogout={handleLogout}
     />
    </Navbar>
    );
  };

export default HornNavbar;
